
import React ,{ Component } from 'react';
import {Container, Row, Col,Image,Button,Form,InputGroup,OverlayTrigger,Tooltip  } from 'react-bootstrap';
import { getAPICallData } from '../../services/MemberService';
import { withRouter,Link } from "react-router-dom";
import SelectBox from '../SelectDropDown/SelectDropDown';
import { components } from 'react-select';
import jwt_decode from "jwt-decode";
import CardLessDataTableWithSearchLimit10 from '../datatables/CardLessDataTableWithSearchLimit10';
import loader from '../../images/loader.gif';
import { scroller } from "react-scroll";
import UpdateVoterVerification from './UpdateVoterVerification';
import VotersModificationSectionAD2024JAN from '../VotersModificationAD2024JAN/VotersModificationSectionAD2024JAN';
import VotersModificationSectionAD2023JANOCT from '../VotersModificationAD2023JANOCT/VotersModificationSectionAD2023JANOCT';
import CardLessDataTableSearchFilterLimit10 from '../datatables/CardLessDataTableSearchFilterLimit10';

const DropdownIndicator = props => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-6q0nyr-Svg"><path fill="currentColor" d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
            </components.DropdownIndicator>
        )
    );
  };

class VotersVerification extends Component {
    constructor(props) {
        super(props)
        this.state = {
            chatID: window.User !=undefined ? window.User.chatID : "943827154",
            userAccessListArr:props?.location?.params?.userAccessList == undefined ? "" : props?.location?.params?.userAccessList,
            boothIdsList:[],
            boothId:"0",
            boothNo:"",
            boothIdValue:{value: "All",label: "All"},
            votersUpdatesArr:[],
            votersUpdateCheck:0,
            VMDetailsInABoothArr:[],
            VMDetailsInABoothCheck:0,
            VMTableHeading:"",
            VMDetailsBlockShow:false,

            voterIdDeocodeValSet:"",
            voterIdEncodeValSet:"",
            VMMobileNo:"",
            isUpdated:"",

            ValidateVMParty:"",
            ValidateVMMobileNo:"",
            ValidateVMReason:"",

            party_ids_Arr:[{'value':872,'label':'TDP'},{'value':1117,'label':'YSRC'},{'value':1892,'label':'JSP'},{'value':1887,'label':'Others'}],
            partyIdStr:"",
            partyIdStrValue:"",

            caste_ids_Arr:[{'value':228, 'label':'Aandh '},{'value':326, 'label':'AASADULA '},
                            {'value':75, 'label':'Achukuntla Vandlu '},{'value':312, 'label':'Adi Dravida '},{'value':224, 'label':'AdiAndhra '},{'value':461, 'label':'Agamudayar '},{'value':309, 'label':'Agamudi Mudaliar '},{'value':121, 'label':'Agaru '},{'value':1, 'label':'Agnikula kshathriya '},{'value':199, 'label':'Anamakh '},{'value':200, 'label':'Andhravida '},{'value':122, 'label':'Arae '},{'value':388, 'label':'Arakalies and Surabi natakalavallu '},
                            {'value':201, 'label':'Arapamala '},{'value':347, 'label':'Arava '},{'value':387, 'label':'Are Marathi '},{'value':123, 'label':'Arekatika '},
                            {'value':202, 'label':'Aremala '},{'value':177, 'label':'Arundatheeya '},{'value':329, 'label':'Arwa Mala '},{'value':76, 'label':'Arya Kshathrya '},{'value':124, 'label':'Atagara '},{'value':397, 'label':'Atirasa '},{'value':77, 'label':'Avusala '},
                            {'value':396, 'label':'Ayyaraka '},{'value':2, 'label':'Badar '},{'value':229, 'label':'Bagatha '},{'value':3, 'label':'Balasanthu '},{'value':296, 'label':'Balija '},{'value':467, 'label':'Balija Kapu '},{'value':4, 'label':'Banda '},{'value':5, 'label':'Bandara '},{'value':353, 'label':'Banjara '},{'value':230, 'label':'Barhika Duliya '},{'value':203, 'label':'Barigi '},{'value':125, 'label':'Batraju '},{'value':162, 'label':'Bavuri '},
                            {'value':120, 'label':'BC - C (Cristians) '},{'value':178, 'label':'Bedajangam '},{'value':204, 'label':'Begara '},{'value':442, 'label':'Behar '},{'value':179, 'label':'Bendla '},
                            {'value':449, 'label':'Bengali '},{'value':342, 'label':'Beri Sheety '},{'value':6, 'label':'Bestha '},{'value':391, 'label':'Bhadbhunja '},{'value':7, 'label':'Bhahurupi '},{'value':390, 'label':'Bhunjwa '},{'value':8, 'label':'Bikshaka Vruthi '},{'value':439, 'label':'Biksham Gunta '},{'value':231, 'label':'Bil '},{'value':403, 'label':'Bindla '},{'value':331, 'label':'Binedu '},{'value':416, 'label':'Bodo Gadaba '},{'value':306, 'label':'Bondili '},{'value':293, 'label':'Boya '},{'value':284, 'label':'Brahmin '},{'value':9, 'label':'Buda Bukkala '},{'value':180, 'label':'Budaga Jangam '},{'value':389, 'label':'Budubunjala '},{'value':126, 'label':'Bukka '},{'value':354, 'label':'Bukka Ayyavara '},{'value':404, 'label':'Byagara '},{'value':405, 'label':'Chachati '},{'value':444, 'label':'Chacherlu '},{'value':406, 'label':'Chalavadi '},{'value':205, 'label':'Challavadi '},{'value':181, 'label':'Chamar '},{'value':182, 'label':'Chambar '},{'value':410, 'label':'Chanchandi '},{'value':164, 'label':'Chandala '},{'value':163, 'label':'Chavati '},{'value':232, 'label':'Chenchu Varu '},{'value':233, 'label':'Chenchumuni '},{'value':127, 'label':'Chimpollu '},{'value':78, 'label':'Chithari '},
                            {'value':79, 'label':'Chithrakara '},{'value':445, 'label':'Chitti Karanam '},{'value':11, 'label':'Chopamali '},{'value':459, 'label':'Christian '},{'value':470, 'label':'Converted Harijans '},{'value':183, 'label':'Dakkal/Dakkala Varu '},{'value':355, 'label':'Damala '},{'value':165, 'label':'Dandasi '},{'value':12, 'label':'Dasari (BC-A) '},{'value':128, 'label':'Dasari (BC-D) '},{'value':234, 'label':'Deseeya kondulu '},{'value':235, 'label':'Desiya Dondulu '},{'value':80, 'label':'Devanga '},{'value':13, 'label':'Devara Vandlu '},{'value':184, 'label':'Dhor '},{'value':423, 'label':'Dhulia '},{'value':167, 'label':'DomDombara '},{'value':14, 'label':'Dommara '},{'value':236, 'label':'Dondra Kodulu '},{'value':81, 'label':'Dudekula '},{'value':82, 'label':'Ediga '},{'value':321, 'label':'EKILA '},{'value':352, 'label':'Ekiri '},{'value':15, 'label':'Ellamma Vandlu '},{'value':16, 'label':'Ellasi '},{'value':345, 'label':'Erla '},{'value':237, 'label':'Gadabalu '},{'value':415, 'label':'Gadabas '},{'value':129, 'label':'Gadava '},{'value':318, 'label':'Gajula Balija '},{'value':83, 'label':'Gamalla Kalali '},{'value':84, 'label':'Gandla '},{'value':18, 'label':'Ganga Varu '},{'value':17, 'label':'Gangaputhra '},{'value':19, 'label':'Gangireddu Varu '},{'value':340, 'label':'Ganuga Sheety '},{'value':168, 'label':'Gasi '},{'value':130, 'label':'Gavara '},{'value':407, 'label':'Ghasi '},{'value':131, 'label':'Ginghar '},{'value':85, 'label':'Giniyar '},{'value':170, 'label':'Godagali '},{'value':185, 'label':'Godari '},{'value':20, 'label':'Gondlu '},{'value':238, 'label':'Gondu '},{'value':206, 'label':'Gosam '},{'value':411, 'label':'Gosangi '},{'value':357, 'label':'Gotrala '},{'value':239, 'label':'Goud-ST '},{'value':86, 'label':'Gouda '},{'value':240, 'label':'Goudh '},{'value':87, 'label':'Goundla '},{'value':21, 'label':'Gudala '},{'value':392, 'label':'Gudia '},{'value':393, 'label':'Gudiya '},{'value':417, 'label':'Gutob Gadaba '},{'value':408, 'label':'Haddi '},
                            {'value':169, 'label':'Haddi (or) Relli chachandi '},{'value':446, 'label':'Harijans '},{'value':132, 'label':'Hatkhar '},{'value':419, 'label':'Hill Reddis '},{'value':207, 'label':'Huleya '},{'value':208, 'label':'Huleya Dasari '},{'value':186, 'label':'Jaggali '},{'value':412, 'label':'JaJnbllvulu '},{'value':332, 'label':'Jakkula '},{'value':22, 'label':'Jalari '},
                            {'value':187, 'label':'Jambavulu '},{'value':88, 'label':'Jandra '},{'value':23, 'label':'Jangam '},{'value':241, 'label':'Jathapass '},{'value':24, 'label':'Jogi '},{'value':341, 'label':'Jogula '},{'value':25, 'label':'Joshinandala Bala '},{'value':133, 'label':'Kachi '},{'value':26, 'label':'Kaikadi '},{'value':89, 'label':'Kaikala '},{'value':438, 'label':'Kaitha Lambadi(Labhana) '},
                            {'value':134, 'label':'Kakkana '},{'value':335, 'label':'Kalai Balija '},{'value':135, 'label':'Kalavanthulu Ganika '},{'value':324, 'label':'KALINGA '},{'value':440, 'label':'Kalinga Vysya '},{'value':418, 'label':'kallayi gadaba '},{'value':27, 'label':'Kalli Kapu '},{'value':290, 'label':'Kamma '},{'value':90, 'label':'Kammara (BC) '},{'value':242, 'label':'Kammara (ST) '},{'value':91, 'label':'Kamsali/Vishva Bramhana '},{'value':92, 'label':'Kanchra '},{'value':136, 'label':'Kandhra '},{'value':28, 'label':'Kanjara Battu '},{'value':288, 'label':'Kapu '},{'value':466, 'label':'Kapu Kapu '},{'value':469, 'label':'Kapu-ST '},{'value':304, 'label':'KARANAM '},{'value':323, 'label':'KARIKALABHAKTHULA '},{'value':93, 'label':'Karna Bakthulu '},{'value':322, 'label':'KARNABHAKTHULA '},{'value':358, 'label':'Kasikapadi '},{'value':94, 'label':'Kathri '},{'value':29, 'label':'Kati Papala '},{'value':243, 'label':'Katunaikan '},{'value':333, 'label':'Kavali '},{'value':431, 'label':'Kerala '},{'value':359, 'label':'Keuta '},{'value':360, 'label':'Keviti '},{'value':361, 'label':'Kevuto '},{'value':30, 'label':'Kinthala Kalinga '},{'value':31, 'label':'Kirathaka '},{'value':244, 'label':'Kodhu '},{'value':245, 'label':'Kodi '},{'value':420, 'label':'Kolam '},{'value':421, 'label':'Kolawar '},{'value':188, 'label':'Koluvula Vandlu '},{'value':32, 'label':'Kompara/Reddika '},{'value':246, 'label':'Konda Doralu '},{'value':247, 'label':'Konda Kapulu '},{'value':248, 'label':'Konda Reddlu '},{'value':250, 'label':'Kondlu '},{'value':137, 'label':'Koppula Velama '},{'value':251, 'label':'Koputiya '},{'value':252, 'label':'Koram '},{'value':33, 'label':'Korcha '},{'value':138, 'label':'Kosti '},{'value':433, 'label':'Kotiya '},{'value':253, 'label':'Kotiya Benthu '},{'value':254, 'label':'Koya '},{'value':139, 'label':'Krushna Balija '},{'value':34, 'label':'Kshathriya (BC) '},{'value':291, 'label':'Kshatriya (OC) '},{'value':255, 'label':'Kuliya '},{'value':256, 'label':'Kulwalapai '},{'value':95, 'label':'Kummara '},{'value':35, 'label':'Kunapuli '},{'value':429, 'label':'Kunkuma '},{'value':475, 'label':'Kuraba '},{'value':362, 'label':'Kurakala '},{'value':382, 'label':'Kurni '},
                            {'value':96, 'label':'Kuruma '},{'value':257, 'label':'Kuttiya Kodulu '},{'value':317, 'label':'Labbai '},{'value':97, 'label':'Laddaf '},{'value':402, 'label':'Lakkamari Kapu '},{'value':363, 'label':'Lambada '},{'value':258, 'label':'Lambadi '},{'value':313, 'label':'Lingayat '},{'value':384, 'label':'Lodh '},{'value':386, 'label':'Lodha '},{'value':385, 'label':'Lodhi '},{'value':189, 'label':'Madiga '},{'value':190, 'label':'Madiga Dasu '},{'value':209, 'label':'Madisi Kuruva/Madaari Kuruva '},{'value':210, 'label':'Mahar '},{'value':36, 'label':'Mahathar '},{'value':211, 'label':'Mala '},{'value':212, 'label':'Mala Dasari '},{'value':213, 'label':'Mala Hannai '},{'value':214, 'label':'Mala Jangam '},{'value':216, 'label':'Mala Masthi '},{'value':217, 'label':'Mala Sala '},{'value':218, 'label':'Mala sanyasi '},{'value':427, 'label':'Maladasu '},{'value':140, 'label':'Mali '},{'value':259, 'label':'Malin '},{'value':37, 'label':'Mandala (BC) '},{'value':219, 'label':'Mandala (SC) '},{'value':364, 'label':'Mandula '},{'value':191, 'label':'Mang Garodi '},{'value':192, 'label':'Manga '},{'value':260, 'label':'Manna Dora '},{'value':220, 'label':'Manne '},{'value':448, 'label':'Mannepu '},{'value':261, 'label':'Mannevaru '},{'value':315, 'label':'MARATI '},{'value':330, 'label':'MARWADI '},{'value':225, 'label':'Masthi '},{'value':193, 'label':'Masthima '},{'value':194, 'label':'Mathangi '},{'value':262, 'label':'Mathaya Vavaras (or) Kuttu Vavaras '},{'value':141, 'label':'Mathula '},{'value':305, 'label':'MAYDARA '},{'value':39, 'label':'Medari '},{'value':171, 'label':'Mehthar '},{'value':319, 'label':'Mera Darji '},{'value':226, 'label':'Mitha Iyala Varu '},{'value':195, 'label':'Mochi '},{'value':301, 'label':'Mohamad '},{'value':40, 'label':'Mondi Banda '},{'value':41, 'label':'Mondi Varu '},{'value':42, 'label':'Mondipatta '},{'value':196, 'label':'Moochi '},{'value':98, 'label':'Muchi '},{'value':460, 'label':'Mudaliar '},{'value':143, 'label':'Mudhiraj '},{'value':263, 'label':'Muka Dora '},{'value':314, 'label':'MUNDALA '},{'value':144, 'label':'Munnoor Kapu '},{'value':292, 'label':'Muslim '},{'value':145, 'label':'Mutharasi '},{'value':43, 'label':'Muthyalamma Vandlu '},{'value':428, 'label':'Myralu '},{'value':451, 'label':'N/A '},{'value':348, 'label':'Nadar '},{'value':435, 'label':'Nagaralu '},{'value':99, 'label':'Nagavaddilu '},{'value':146, 'label':'Nagavamsha '},{'value':147, 'label':'Nagavasam '},{'value':264, 'label':'Naik '},{'value':265, 'label':'Naikpoth '},{'value':100, 'label':'Nakhan '},{'value':44, 'label':'Nakkala '},{'value':349, 'label':'Nambi '},
                            {'value':45, 'label':'Nashadi '},{'value':101, 'label':'Nashni/Kurni '},{'value':307, 'label':'Natari '},{'value':426, 'label':'Nayaka '},{'value':344, 'label':'Nayani Varu '},{'value':365, 'label':'Nayanivaru '},{'value':38, 'label':'Nayee Brahmin '},{'value':47, 'label':'Nayyala '},{'value':102, 'label':'Neelikanti '},{'value':148, 'label':'Nelli '},{'value':325, 'label':'NEPALI '},{'value':48, 'label':'Nera Pravruthi Kalavaru '},{'value':49, 'label':'Nershakari '},{'value':381, 'label':'Nessi '},{'value':447, 'label':'Nethekani '},{'value':50, 'label':'Nokkara '},{'value':432, 'label':'Nooka Dora '},{'value':298, 'label':'Oreganti Reddy '},{'value':458, 'label':'OTHERS '},{'value':472, 'label':'OTHERS-BC '},{'value':471, 'label':'OTHERS-OC '},{'value':473, 'label':'OTHERS-SC '},{'value':474, 'label':'OTHERS-ST '},{'value':103, 'label':'Padmashali '},{'value':166, 'label':'Paidi/pano '},
                            {'value':424, 'label':'Paiko '},{'value':172, 'label':'Paki (or) Mothi '},{'value':366, 'label':'Pala Ekari '},{'value':367, 'label':'Palegaru '},{'value':300, 'label':'Pallepu Kapu '},{'value':310, 'label':'Palli '},{'value':343, 'label':'Palli Kapu '},{'value':346, 'label':'Palli Reddy '},{'value':51, 'label':'Pambala '},{'value':174, 'label':'Pamidi '},{'value':52, 'label':'Pamula '},{'value':227, 'label':'Panchama (or) Pariyuhi '},{'value':450, 'label':'Panda '},{'value':150, 'label':'Panjari '},{'value':53, 'label':'Pannari '},{'value':266, 'label':'Parangi Parcha '},{'value':422, 'label':'Pardhan '},{'value':54, 'label':'Parthi '},{'value':151, 'label':'Paspi '},{'value':395, 'label':'Passi '},{'value':303, 'label':'Pathan '},{'value':104, 'label':'Patkhar '},{'value':55, 'label':'Patlavu '},{'value':436, 'label':'Patnayak '},{'value':434, 'label':'Patnayak '},{'value':316, 'label':'PATRA '},{'value':299, 'label':'Pattapu '},{'value':454, 'label':'Pattusali '},{'value':56, 'label':'Peddaboya '},{'value':57, 'label':'Peddama Vandlu '},{'value':105, 'label':'Perika '},{'value':106, 'label':'Perika Balija '},{'value':107, 'label':'Pinjari/Noorbash '},{'value':59, 'label':'Piriki Muggula '},{'value':58, 'label':'Pitchiguntla '},{'value':152, 'label':'Polinati Velama '},{'value':368, 'label':'Pondara '},{'value':153, 'label':'Poosala '},{'value':369, 'label':'Poosala '},{'value':267, 'label':'Porja '},{'value':60, 'label':'Porvam Bikshaka Vruthi '},{'value':462, 'label':'Pusala '},{'value':425, 'label':'Putiya '},{'value':61, 'label':'Rajaka '},{'value':370, 'label':'Rajannala '},{'value':334, 'label':'Rajput '},{'value':289, 'label':'Raju '},{'value':268, 'label':'Rajugondu '},{'value':154, 'label':'Rangaraju/Bhavasara Kshatriya '},
                            {'value':441, 'label':'Ravula '},{'value':285, 'label':'Reddy '},{'value':269, 'label':'Reddy Dora '},{'value':465, 'label':'Reddy Kapu '},{'value':468, 'label':'Reddy Reddy '},{'value':175, 'label':'Relli '},{'value':270, 'label':'Rona Rena '},{'value':443, 'label':'Sabeerlu '},{'value':452, 'label':'Sadara '},{'value':155, 'label':'Sadushetti '},{'value':371, 'label':'Saikalgar '},{'value':108, 'label':'Sakulasali '},{'value':197, 'label':'Samagara '},{'value':372, 'label':'Samanthula '},{'value':221, 'label':'Samband '},{'value':222, 'label':'Sambas '},{'value':271, 'label':'Sandrona '},{'value':109, 'label':'Sangundam '},{'value':176, 'label':'Sapru '},{'value':272, 'label':'Sardhan '},{'value':156, 'label':'Sathani '},{'value':273, 'label':'Savaras Kapusavaras '},{'value':311, 'label':'Seervi '},{'value':110, 'label':'Settibalija '},{'value':111, 'label':'Shilpi '},{'value':373, 'label':'Siddula '},{'value':274, 'label':'Sidopaiko '},{'value':430, 'label':'Sikh '},{'value':374, 'label':'Sikligar '},{'value':383, 'label':'Silpis viswakarma '},{'value':198, 'label':'Sindollu '},{'value':351, 'label':'Singh '},{'value':401, 'label':'Sistakaranam '},{'value':398, 'label':'sondi '},{'value':375, 'label':'Sountia '},{'value':112, 'label':'Sri Sayan '},{'value':275, 'label':'Sugaleelu '},{'value':399, 'label':'sundi '},{'value':394, 'label':'Surya Balija '},{'value':339, 'label':'Suryavamsha Rajulu '},{'value':302, 'label':'Syed '},{'value':328, 'label':'Telaga '},{'value':350, 'label':'Telikula '},{'value':113, 'label':'Telugu Matlade Varu '},{'value':114, 'label':'Thalikula '},{'value':157, 'label':'Thammali '},{'value':158, 'label':'Thenugollu '},{'value':276, 'label':'Thikakariya Kodulu '},{'value':115, 'label':'Thogati Thogata '},{'value':173, 'label':'Thoti (BC) '},{'value':277, 'label':'Thoti (ST) '},{'value':159, 'label':'Thurapu Kapu/Gajula Kapu '},{'value':376, 'label':'Tolagari '},{'value':160, 'label':'Uppara/Sankara '},{'value':338, 'label':'Uppu vadde '},{'value':377, 'label':'Vadabalija '},{'value':283, 'label':'Vaddera '},{'value':62, 'label':'Vaddi '},{'value':63, 'label':'Vaddolu '},{'value':116, 'label':'Vadla '},{'value':117, 'label':'Vadra '},{'value':118, 'label':'Vadrangi '},{'value':64, 'label':'Valli '},{'value':65, 'label':'Valli Reddy '},{'value':414, 'label':'Valluvan '},{'value':278, 'label':'Valmiki '},{'value':378, 'label':'Valmiki '},{'value':66, 'label':'Valmiki Boya '},{'value':455, 'label':'Vamsharaj '},{'value':437, 'label':'Vanjari '},{'value':67, 'label':'Vanne Kapu '},{'value':68, 'label':'Vanne Reddy '},{'value':336, 'label':'Vannekapu '},{'value':308, 'label':'Vanyakulakshatriya '},{'value':400, 'label':'varala '},{'value':69, 'label':'Vatti Kothala '},{'value':70, 'label':'Vedabaliga '},
                            {'value':379, 'label':'Veerabhadreeya '},{'value':327, 'label':'Veerashaiva LingayatLingabalija '},{'value':287, 'label':'Velama '},{'value':71, 'label':'Venka Kula '},{'value':72, 'label':'Vera Musti '},{'value':73, 'label':'Vodde Yeddelu '},{'value':453, 'label':'Vokkaliga '},{'value':279, 'label':'Voriya/bentu Voriya '},{'value':380, 'label':'Vyakula '},{'value':286, 'label':'Vysya '},{'value':161, 'label':'Yadava '},{'value':337, 'label':'Yalam Reddy '},{'value':74, 'label':'Yata '},{'value':413, 'label':'Yatala '},{'value':223, 'label':'Yellimal Varu '},{'value':280, 'label':'Yenadi '},{'value':281, 'label':'Yerukala '},{'value':282, 'label':'Yoniti Kodulu'}],
            casteIdStr:"",
            casteIdStrValue:"",

            reason_ids_Additions_Arr:[{'value':1,'label':'Available'},{'value':2,'label':'Death'},{'value':3,'label':'Migrated Permanently'},{'value':4,'label':'Migrated Temporary'},{'value':5,'label':'Fake/Not available'},{'value':7,'label':'Double Entry'}],
            reasonAddIdStr:"",
            reasonAddStrValue:"",

            is_nonLocal_Arr:[{'value':'Y','label':'Y'},{'value':'N','label':'N'}],
            is_nonLocalVoter:"",
            is_nonLocalVoter_value:"",

            updateVoterVerificationModel:false,
            updateVoterModifiLoadingSymbol:"hide",
            updateVoterModifiMsg:"",
            getCurrentLocationCoordinatesForVV:{},
            filterBlockOpenVAC:false,

            casteCheckedCondAll:true,
            casteCheckedCondYes:false,
            casteCheckedCondNo:false,

            nonLocalCheckedCondYes:false,nonLocalCheckedCondNo:false,nonLocalCheckedCondAll:true,
            mobileCheckedCondYes:false,mobileCheckedCondNo:false,mobileCheckedCondAll:true,
            partyCheckedCondYes:false,partyCheckedCondNo:false,partyCheckedCondAll:true,
            residenceStatusCheckedCondYes:false,residenceStatusCheckedCondNo:false,residenceStatusCheckedCondAll:true,

            casteUpdatedVal:"",
            partyUpdatedVal:"",
            mobileUpdatedVal:"",
            residenceStatusUpdatedVal:"",
            nonLocalUpdatedVal:"",

            boothIdForGetVoters:"",
            isUpdatedForGetVoters:"",
            getVoterFilesUpdatedSymbol:"hide",

            attributesBlock:true,
            votersBlock:false,
            votersAD2023JANOCTBlock:false,
            votersShowBlockType:"2024JAN",

            locationUpdated:"",
            validateLocationUpdated:""
            
        }
        
    }

    componentDidMount() {
        let userAccessList = this.state.userAccessListArr;
        if(userAccessList != null && userAccessList.status == "Success" ){
            if(userAccessList.boothList != null && userAccessList.boothList.length>0){
                let boothListArr=[];
                const obj1 = {
                    value: "All",
                    label: "All",
                }
                boothListArr.push(obj1);
                userAccessList.boothList.map(item => {
                    const obj = {
                        value: item.id,
                        label: "Booth No -"+item.name,
                        attr_mapped:item.isMapped
                    }
                    boothListArr.push(obj);
                    
                });
                this.setState({ boothIdsList: boothListArr });
                this.getVoterVerificationUpdationStatus('',"Booth");
                
            }
        }else{
            this.props.history.push({pathname:"/dashboard"});
        }
    }
    isFilterBlockOpenVAC = () => {
        this.setState({filterBlockOpenVAC:!this.state.filterBlockOpenVAC });
    }

    checkParameterValue = (e,value,checkType) => {
        if(checkType == "caste"){
            if(value == 'Y'){
                this.setState({ casteCheckedCondYes:true,casteCheckedCondNo:false,casteCheckedCondAll:false});
            }else if(value == 'N'){
                this.setState({ casteCheckedCondYes:false,casteCheckedCondNo:true,casteCheckedCondAll:false});
            }else if (value == ''){
                this.setState({ casteCheckedCondYes:false,casteCheckedCondNo:false,casteCheckedCondAll:true});
            }

            this.setState({ casteUpdatedVal:value});
        }else if(checkType == "party"){
            if(value == 'Y'){
                this.setState({ partyCheckedCondYes:true,partyCheckedCondNo:false,partyCheckedCondAll:false});
            }else if(value == 'N'){
                this.setState({ partyCheckedCondYes:false,partyCheckedCondNo:true,partyCheckedCondAll:false});
            }else if (value == ''){
                this.setState({ partyCheckedCondYes:false,partyCheckedCondNo:false,partyCheckedCondAll:true});
            }

            if (e.target.checked == true) {
                this.setState({ partyUpdatedVal:value});
            }
        }else if(checkType == "mobile"){
            if(value == 'Y'){
                this.setState({ mobileCheckedCondYes:true,mobileCheckedCondNo:false,mobileCheckedCondAll:false});
            }else if(value == 'N'){
                this.setState({ mobileCheckedCondYes:false,mobileCheckedCondNo:true,mobileCheckedCondAll:false});
            }else if (value == ''){
                this.setState({ mobileCheckedCondYes:false,mobileCheckedCondNo:false,mobileCheckedCondAll:true});
            }

            if (e.target.checked == true) {
                this.setState({ mobileUpdatedVal:value});
            }
        }else if(checkType == "residenceStatus"){
            if(value == 'Y'){
                this.setState({ residenceStatusCheckedCondYes:true,residenceStatusCheckedCondNo:false,residenceStatusCheckedCondAll:false});
            }else if(value == 'N'){
                this.setState({ residenceStatusCheckedCondYes:false,residenceStatusCheckedCondNo:true,residenceStatusCheckedCondAll:false});
            }else if (value == ''){
                this.setState({ residenceStatusCheckedCondYes:false,residenceStatusCheckedCondNo:false,residenceStatusCheckedCondAll:true});
            }

            if (e.target.checked == true) {
                this.setState({ residenceStatusUpdatedVal:value});
            }
        }else if(checkType == "nonLocal"){
            if(value == 'Y'){
                this.setState({ nonLocalCheckedCondYes:true,nonLocalCheckedCondNo:false,nonLocalCheckedCondAll:false});
            }else if(value == 'N'){
                this.setState({ nonLocalCheckedCondYes:false,nonLocalCheckedCondNo:true,nonLocalCheckedCondAll:false});
            }else if (value == ''){
                this.setState({ nonLocalCheckedCondYes:false,nonLocalCheckedCondNo:false,nonLocalCheckedCondAll:true});
            }

            if (e.target.checked == true) {
                this.setState({ nonLocalUpdatedVal:value});
            }
        }
       
    }

    handleOnchangeInputBox = (e) => {
        console.log("handleInputChange", e.target.name, e.target.value)
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value });
        
      }

      handleOnchangeAllowAlphabiticalInputBox = () => {
        this.setState({validateLocationUpdated:""});
        var regex = /^[a-zA-Z]*$/;
        if (!regex.test(this.state.locationUpdated)) {
            this.setState({validateLocationUpdated:"Please Enter Only Alphabets...",locationUpdated:"" });
            return true;
        } 
      }

    handleOnchangeSelectBoxNew = (ename, evalue) =>{
        const name = ename;
        const value = evalue;
    
        if(name == "boothId"){
          this.setState({ VMDetailsInABoothCheck: 0,VMDetailsInABoothArr:[],VMTableHeading:"",VMDetailsBlockShow:false});

          let getBoothIdName = this.state.boothIdsList.find((a) => a.value == value);
            this.setState({
              boothIdValue: {
                  value: getBoothIdName.value,
                  label: getBoothIdName.label
              }
          });
    
          this.setState({ boothId: getBoothIdName.value,boothNo:"Booth "+getBoothIdName.label});
          if(value == "All"){
            this.getVoterVerificationUpdationStatus('',"Booth");
          }else{
            this.getVoterVerificationUpdationStatus(value,"Booth");
          }
         
        
        }else if(name == "partyIdStr"){
            let partyIdName = this.state.party_ids_Arr.find((a) => a.value == value);
            this.setState({
                partyIdStrValue: {
                  value: partyIdName.value,
                  label: partyIdName.label
              }
          });

    
          this.setState({ partyIdStr: value});
        }else if(name == "casteIdStr"){
            let casteIdName = this.state.caste_ids_Arr.find((a) => a.value == value);
            this.setState({
                casteIdStrValue: {
                  value: casteIdName.value,
                  label: casteIdName.label
              }
          });

    
          this.setState({ casteIdStr: value});
        }else if(name == "reasonAddIdStr"){
            let reasonAddIdName = this.state.reason_ids_Additions_Arr.find((a) => a.value == value);
            this.setState({
                reasonAddStrValue: {
                  value: reasonAddIdName.value,
                  label: reasonAddIdName.label
              }
          });

    
          this.setState({ reasonAddIdStr: value});
        }else if(name == "is_nonLocalVoter"){
            let nonLocalIdName = this.state.is_nonLocal_Arr.find((a) => a.value == value);
            this.setState({
                is_nonLocalVoter_value: {
                  value: nonLocalIdName.value,
                  label: nonLocalIdName.label
              }
          });

    
          this.setState({ is_nonLocalVoter: value});
        }
    }
  
    getVoterVerificationUpdationStatus = (boothId,type) => {
        this.setState({ votersUpdateCheck: 0,votersUpdatesArr:[]});
        const obj =  
            JSON.stringify({ 
            "chatId" :this.state.chatID,
            "type" : type,
            "boothId" : boothId 
            }
        ); 

        getAPICallData(obj,"verification/getVoterVerificationUpdationStatus")
            .then((res) => res.json())
            .then((data) => {
                if(data !=null && data.length>0){
                    this.setState({ votersUpdateCheck: 0,votersUpdatesArr:data});
                }else{
                    this.setState({ votersUpdateCheck: 1,votersUpdatesArr:[]});
                }
            });
  }


votersUpdatesDisplayColumns() {

    let columns = [
        {
            dataField: "Booth",
            text: "Booth",
            sort: true,
            
            
        },
        {
            dataField: "Total_Voters",
            text: "Total",
            sort: true,
            
        },
        {
            dataField: "verified",
            text: "V",
            sort: true,
            formatter: this.actionsFormatterForVerifiedDeletions.bind(this),
            
        },
        {
            dataField: "verified_perc",
            text: "%",
            sort: true,
            formatter: this.actionsFormatterForVerifiedPercDeletions.bind(this),
            
        },
        {
            dataField: "Pending",
            text: "P",
            sort: true,
            formatter: this.actionsFormatterForPendingDeletions.bind(this),
            
        },
        {
            dataField: "Pending_perc",
            text: "%",
            sort: true,
            formatter: this.actionsFormatterForPendingPercDeletions.bind(this),
        },
        
    
    ];
    return columns;
}


actionsFormatterForVerifiedDeletions = (cell, row, rowIndex, formatExtraData) => {

  
    return (
        <>
            <span className='f-12 color_green' style={{textAlign:"left",marginLeft:"0px"}}>
                {
                    row.verified >0 ?
                    (<span style={{textAlign:"left",marginLeft:"0px"}} ><span style={{textAlign:"left",marginLeft:"0px"}}  className='fw-bold text-decoraion-underline cursor_pointer' onClick={() => this.getBoothWiseVotersUpdateDetila(row.BoothId,row.Booth,"Y","withOutFilters","verified")}>{row.verified}</span></span>)
                    :
                    (<span style={{textAlign:"left",marginLeft:"0px"}} className='fw-bold'>0</span>)
                }
                
            </span>
           
         </>

        
     );
    
}


actionsFormatterForVerifiedPercDeletions = (cell, row, rowIndex, formatExtraData) => {

  
    return (
        <>
            <span className='f-12 color_green ' style={{textAlign:"left",marginLeft:"0px"}}>
                {
                    row.verified >0 ?
                    (<span style={{textAlign:"left",marginLeft:"0px"}} ><span style={{textAlign:"left",marginLeft:"0px"}}  className='fw-bold' >{row.verified_perc}</span> </span>)
                    :
                    (<span style={{textAlign:"left",marginLeft:"0px"}} className='fw-bold'>0</span>)
                }
            </span>
           
         </>

        
     );
    
}



actionsFormatterForPendingDeletions = (cell, row, rowIndex, formatExtraData) => {

  
    return (
        <>
            <span className='f-12 color_red ' style={{textAlign:"left",marginLeft:"0px"}}>
                {
                    row.Pending >0 ?
                    (<span style={{textAlign:"left",marginLeft:"0px"}} ><span style={{textAlign:"left",marginLeft:"0px"}}  className='fw-bold text-decoraion-underline cursor_pointer' onClick={() => this.getBoothWiseVotersUpdateDetila(row.BoothId,row.Booth,"N","withOutFilters","Pending")}>{row.Pending}</span> </span>)
                    :
                    (<span style={{textAlign:"left",marginLeft:"0px"}} className='fw-bold'>{row.Pending}</span>)
                }
            </span>
           
         </>

        
     );
    
}


actionsFormatterForPendingPercDeletions = (cell, row, rowIndex, formatExtraData) => {

  
    return (
        <>
            <span className='f-12 color_red ' style={{textAlign:"left",marginLeft:"0px"}}>
                {
                    row.Pending >0 ?
                    (<span style={{textAlign:"left",marginLeft:"0px"}} ><span style={{textAlign:"left",marginLeft:"0px"}}  className='fw-bold' >{row.Pending_perc}</span> </span>)
                    :
                    (<span style={{textAlign:"left",marginLeft:"0px"}} className='fw-bold'>0</span>)
                }
            </span>
           
         </>

        
     );
    
}


votersUpdatesDisplayData = () => {
    let votersData = [];
    if(this.state.votersUpdatesArr.length>0){
        
        for (let i = 0; i < this.state.votersUpdatesArr.length; i++) {

            const locationName = (this.state.votersUpdatesArr[i].partNo);
            const locationId = (this.state.votersUpdatesArr[i].boothId);
            const deletedUpdatedCnt = (this.state.votersUpdatesArr[i].updated);
            const deletedPendingCnt = (this.state.votersUpdatesArr[i].pending);
            const deletedUpdatedPercentage = (this.state.votersUpdatesArr[i].updatedPercentage);
            const deletedPendingPercentage = (this.state.votersUpdatesArr[i].pendingPercentage);
            const votersCnt = (this.state.votersUpdatesArr[i].totalVoters);
            
            const obj = {
                Booth:(locationName),
                BoothId: locationId,
                Total_Voters:votersCnt,
                verified:deletedUpdatedCnt,
                verified_perc:deletedUpdatedPercentage,
                Pending:deletedPendingCnt,
                Pending_perc:deletedPendingPercentage
            }
            votersData.push(obj);
        } 

        
        
        return votersData;
    }
}

getBoothWiseVotersUpdateDetila = (boothId,boothName,isUpdated,filterType,statusName) => {
    scroller.scrollTo("scroll_top_VM", { 
        duration: 800,
        delay: 0,
        smooth: "easeInOutQuart",
    });
    this.setState({ VMDetailsBlockShow:true});
    this.setState({ VMDetailsInABoothCheck: 0,VMDetailsInABoothArr:[]});
    if(filterType == "withOutFilters"){
        this.setState({ boothIdForGetVoters: boothId,isUpdatedForGetVoters:isUpdated,VMTableHeading: "Booth-"+boothName+" - "+statusName+" Voter Details"});
    }
    
    setTimeout(() => {
    
    const obj =  
            JSON.stringify({ 
            "chatId" :this.state.chatID,
            "boothId" : this.state.boothIdForGetVoters,
            "isUpdated" : this.state.isUpdatedForGetVoters,
            "isStatusUpdated" : this.state.residenceStatusUpdatedVal,
            "isPartyUpdated" : this.state.partyUpdatedVal,
            "isCasteUpdated" : this.state.casteUpdatedVal,
            "isMobileUpdated" : this.state.mobileUpdatedVal,
            "isNonLocalUpdated" : this.state.nonLocalUpdatedVal
            }
        ); 

        getAPICallData(obj,"verification/getVoterDetailsForVerificationInABooth")
            .then((res) => res.json())
            .then((data) => {
                this.setState({filterBlockOpenVAC:false });
                if(data !=null && data.length>0){
                    console.log("ddddddd",data)
                    const decodeVoterDataVM = data.map((item,index) => {

                        var voterIdDecode = item.voterIdStr == "" ? "" : jwt_decode(item.voterIdStr).sub;
                        var voterIdEncoded = (item.voterIdStr);
                        var serialNoStr = item.serialNoStr == "" ? "" : jwt_decode(item.serialNoStr).sub;
                        var voterCardNo = item.voterCardNo == "" ? "" : jwt_decode(item.voterCardNo).sub;
                        var voterName = item.voterName == "" ? "" : jwt_decode(item.voterName).sub;
                        var relation = item.relation == "" ? "" : jwt_decode(item.relation).sub;
                        var relativeName = item.relativeName == "" ? "" : jwt_decode(item.relativeName).sub;
                        var ageStr = item.ageStr == "" ? "" : jwt_decode(item.ageStr).sub;
                        var gender = item.gender == "" ? "" : jwt_decode(item.gender).sub;
                        var houseNo = item.houseNo == "" ? "" : jwt_decode(item.houseNo).sub;
                        var isUpdated = item.isUpdated == "" ? "" : jwt_decode(item.isUpdated).sub;
                        var isMobileUpdated = item.isMobileUpdated == "" ? "" : jwt_decode(item.isMobileUpdated).sub;
                        var isPartyUpdated = item.isPartyUpdated == "" ? "" : jwt_decode(item.isPartyUpdated).sub;
                        var isCasteUpdated = item.isCasteUpdated == "" ? "" : jwt_decode(item.isCasteUpdated).sub;
                        var isNonLocalUpdated = item.isNonLocalUpdated == "" ? "" : jwt_decode(item.isNonLocalUpdated).sub;
                        var isStatusUpdated = item.isStatusUpdated == "" ? "" : jwt_decode(item.isStatusUpdated).sub;
                        
                        return { voterIdDecode,voterIdEncoded,serialNoStr,voterCardNo,voterName,relation,
                            relativeName,ageStr,gender,houseNo,isMobileUpdated,isPartyUpdated,isCasteUpdated,
                            isNonLocalUpdated,isStatusUpdated,isUpdated }
                    });

                    console.log("ddddddd",decodeVoterDataVM)

                    this.setState({ VMDetailsInABoothCheck: 0,VMDetailsInABoothArr:decodeVoterDataVM});
                }else{
                    this.setState({ VMDetailsInABoothCheck: 1,VMDetailsInABoothArr:[]});
                }
            });
        }, 500);
}


sortFuncSerialNoVM(a, b, order, dataField, rowA, rowB)  { 
    if (order == 'desc') {
        
        return parseInt(rowB.voterCardNo)  > parseInt(rowA.voterCardNo) ? 1 : -1;

    } else {
        return parseInt(rowA.voterCardNo)  > parseInt(rowB.voterCardNo) ? 1 : -1;
    }
}

VMDetailsDisplayColumns() {

    let columns = [
        {
            dataField: "serialNo",
            text: "SNO",
            sort: true,
            sortFunc: this.sortFuncSerialNoVM.bind(this),
            formatter: this.actionsFormatterForVMDetailsSerialNo.bind(this),
            
        },
        
        {
            dataField: "voterName",
            text: "voter Name",
            sort: true,
            formatter: this.actionsFormatterForVMDetails.bind(this),
            headerStyle: {
                width: "45%"
            }
        },
        {
            dataField: "Age",
            text: "Age",
            sort: true,
           
            
        },
        {
            dataField: "Gender",
            text: "Gen der",
            sort: true,
        },{
            dataField: "Actions",
            text: "A/c",
            formatter: this.actionsFormatterForUpdateVM.bind(this),
            
        },
    
    ];
    return columns;
}
actionsFormatterForVMDetailsSerialNo = (cell, row, rowIndex, formatExtraData) => {
    return (
       (row.voterCardNo)
       
     );
}

actionsFormatterForVMDetails = (cell, row, rowIndex, formatExtraData) => {

  
    return (
        <span style={{textAlign:"left",marginLeft:"0px"}}>{(row.voterName)} 
            <><br/><span className='f-10 color_red' style={{textAlign:"left",marginLeft:"0px"}}>V - {(row.serialNo)}</span></>
            <><br/><span className='f-10 color_red' style={{textAlign:"left",marginLeft:"0px"}}>HouseNo - {(row.houseNo)}</span></>
           {/* <><br/><span className='f-10 color_red' style={{textAlign:"left",marginLeft:"0px"}}>R - {(row.relativeName)}</span></>
            <><br/><span className='f-10 color_red' style={{textAlign:"left",marginLeft:"0px"}}>Rel - {(row.relation)}</span></>*/}

            <><br/><span className='f-10' style={{textAlign:"left",marginLeft:"0px"}}>
            P - {(row.isPartyUpdated) == 'Y' ? <b className='color_green'>Y</b> : <b className='color_red'>N</b>},
            C - {(row.isCasteUpdated) == 'Y' ? <b className='color_green'>Y</b> : <b className='color_red'>N</b>},
            M - {(row.isMobileUpdated) -= 'Y' ? <b className='color_green'>Y</b> : <b className='color_red'>N</b>},
            N - {(row.isNonLocalUpdated) == 'Y' ? <b className='color_green'>Y</b> : <b className='color_red'>N</b>},
            R - {(row.isStatusUpdated) == 'Y' ? <b className='color_green'>Y</b> : <b className='color_red'>N</b>},
            
            </span></>
        </span>
     );
    
}

actionsFormatterForUpdateVM = (cell, row, rowIndex, formatExtraData) => {
      

    return (
        <>
        {
            row.isUpdated == 'Y'  ?
            (
                <OverlayTrigger key={"top"} placement={"top"}
                    overlay={
                        <Tooltip id={`tooltio-Filter-vm`}>
                        <h6 className='f-14'>Update Verification Status</h6>
                        </Tooltip>
                    }
                    >
                     <span className='cursor_pointer fw-bold color_green' onClick={() => this.updateVoterModificationDts(row)}><i class="fa-solid fa-pen-to-square"></i></span>
                </OverlayTrigger>
               
            )
            :
            (
                <OverlayTrigger key={"top"} placement={"top"}
                    overlay={
                        <Tooltip id={`tooltio-Filter-vm1`}>
                        <h6 className='f-14'>Update Verification Status</h6>
                        </Tooltip>
                    }
                    >
                     <span className='cursor_pointer fw-bold color_red' onClick={() => this.updateVoterModificationDts(row)}><i class="fa-solid fa-pen-to-square"></i></span>
                </OverlayTrigger>
            )
        }
        
        </>
          
     );
}

VMDetailsDisplayData = () => {
    let votersData = [];
    if(this.state.VMDetailsInABoothArr.length>0){
        
        for (let i = 0; i < this.state.VMDetailsInABoothArr.length; i++) {

            const voterIdEncoded = (this.state.VMDetailsInABoothArr[i].voterIdEncoded);
            const serialNo = (this.state.VMDetailsInABoothArr[i].serialNoStr);
            const voterCardNo = (this.state.VMDetailsInABoothArr[i].voterCardNo);
            const voterName = (this.state.VMDetailsInABoothArr[i].voterName);
            const relation = (this.state.VMDetailsInABoothArr[i].relation);
            const relativeName = (this.state.VMDetailsInABoothArr[i].relativeName);
            const ageStr = (this.state.VMDetailsInABoothArr[i].ageStr);
            const gender = (this.state.VMDetailsInABoothArr[i].gender);
            const houseNo = (this.state.VMDetailsInABoothArr[i].houseNo);
            const isUpdated = (this.state.VMDetailsInABoothArr[i].isUpdated);
            const isMobileUpdated = (this.state.VMDetailsInABoothArr[i].isMobileUpdated);
            const isPartyUpdated = (this.state.VMDetailsInABoothArr[i].isPartyUpdated);
            const isCasteUpdated = (this.state.VMDetailsInABoothArr[i].isCasteUpdated);
            const isNonLocalUpdated = (this.state.VMDetailsInABoothArr[i].isNonLocalUpdated);
            const isStatusUpdated = (this.state.VMDetailsInABoothArr[i].isStatusUpdated);
            const voterIdDecode = (this.state.VMDetailsInABoothArr[i].voterIdDecode);
            
            const obj = {
                serialNo:voterCardNo,
                voterName: voterName,
                Age: ageStr,
                Gender: gender,
                voterCardNo:serialNo,
                voterIdEncoded:voterIdEncoded,
                voterIdDecode:voterIdDecode,
                isUpdated:isUpdated,
                houseNo:houseNo,
                relativeName:relativeName,
                relation:relation,
                isMobileUpdated:isMobileUpdated,
                isPartyUpdated:isPartyUpdated,
                isCasteUpdated:isCasteUpdated,
                isNonLocalUpdated:isNonLocalUpdated,
                isStatusUpdated:isStatusUpdated,
                Actions:"Update"
            }
            votersData.push(obj);
        } 

        
        
        return votersData;
    }
}

updateVoterModificationDts = (row) => {
    this.setState({updateVoterVerificationModel:true});
    this.setState({getVoterFilesUpdatedSymbol:"show"});
    this.setState({updateVoterModifiMsg:"",voterIdDeocodeValSet:"",getCurrentLocationCoordinatesForVV:{}});  
    this.setState({partyIdStr:"",mobileNoStr:"",casteIdStr:"",partyIdStrValue:"",casteIdStrValue:"",
    reasonAddIdStr:"",reasonAddStrValue:"",is_nonLocalVoter:"",is_nonLocalVoter_value:"",voterIdEncodeValSet:""
    });

    setTimeout(() => {
        this.setState({voterIdDeocodeValSet:row.voterIdDecode,voterIdEncodeValSet:row.voterIdEncoded});
        navigator.geolocation.getCurrentPosition(this.showLocationVMMappingPostions,this.ShowLocationPermissionError)
       


        const obj =  
            JSON.stringify({ 
            "chatId" :this.state.chatID,
            "voterIdStr" : row.voterIdEncoded,
            
            }); 
        

    
    getAPICallData(obj,"verification/getVoterVerificationDetailsByVoterId")
        .then((res) => res.json())
        .then((data) => {
            this.setState({getVoterFilesUpdatedSymbol:"hide"});  
            if(data !=null){
                if(data.partyId !=""){
                    const decodePartyId = jwt_decode(data.partyId).sub;
                    let partyIdName = this.state.party_ids_Arr.find((a) => a.value == decodePartyId);
                        this.setState({
                            partyIdStrValue: {
                            value: partyIdName.value,
                            label: partyIdName.label
                        },partyIdStr:decodePartyId
                    });
                }
                if(data.casteStateId !=""){
                    const decodecasteId = jwt_decode(data.casteStateId).sub;
                    let casteIdName = this.state.caste_ids_Arr.find((a) => a.value == decodecasteId);
                        this.setState({
                            casteIdStrValue: {
                            value: casteIdName.value,
                            label: casteIdName.label
                        },casteIdStr:decodecasteId
                    });
                }
                if(data.mobileNo != ""){
                    this.setState({VMMobileNo:jwt_decode(data.mobileNo).sub});
                }
                if(data.residenceStatusId !=""){
                    const decoderesId = jwt_decode(data.residenceStatusId).sub;
                    let resIdName = this.state.reason_ids_Additions_Arr.find((a) => a.value == decoderesId);
                        this.setState({
                            reasonAddStrValue: {
                            value: resIdName.value,
                            label: resIdName.label
                        },reasonAddIdStr:decoderesId
                    });
                }
                
                if(data.isNonLocal !=""){
                    const decodeisNonLocal = jwt_decode(data.isNonLocal).sub;
                    let outsidevoterIdName = this.state.is_nonLocal_Arr.find((a) => a.value == decodeisNonLocal);
                        this.setState({
                            is_nonLocalVoter_value: {
                            value: outsidevoterIdName.value,
                            label: outsidevoterIdName.label
                        },is_nonLocalVoter:decodeisNonLocal
                    });
                }
                
            }else{
                this.setState({updateVoterVerificationModel:false});
            }
        });
    }, 500);

    
    
}

showLocationVMMappingPostions = (position) => {
    const getCoordinates =  
        { 
          "latitude" : position.coords.latitude,
          "longitude" : position.coords.longitude,
          "accuracy":position.coords.accuracy
        }
        
    this.setState({getCurrentLocationCoordinatesForVV:getCoordinates});
  }

  ShowLocationPermissionError = (error) => {
    switch (error.code){
        case error.PERMISSION_DENIED:
          alert("User Location Permission is Denied,Please Enable Location Services...(Path:Settings > Privacy > Location Services)");
          break;

          case error.POSITION_UNAVAILABLE:
          alert("User Postion Unavailable Denied");
          break;

          default:
            alert("An unknown error occurred")
    }
}

updateVoterModifiFields = () => {
    this.setState({ValidateVMMobileNo:"",ValidateVMReason:"",validateLocationUpdated:""});
    if(this.state.VMMobileNo != ""){
        if(!this.state.VMMobileNo.match(/^[0-9]+$/)){
            this.setState({ValidateVMMobileNo:"Please Enter Valid Mobile No" });
            return;
            }

        if(this.state.VMMobileNo.length < 10){
            this.setState({ValidateVMMobileNo:"Please Enter Valid Mobile No" });
            return;
        }
    }

    if(this.state.reasonAddIdStr == '' || this.state.reasonAddIdStr == 0){
        this.setState({ValidateVMReason:"Please Select Residence Status" });
        return;
    }

    if(this.state.is_nonLocalVoter == 'Y'){
        if(this.state.locationUpdated == ""){
            this.setState({validateLocationUpdated:"Please Enter Location..." });
            return;
        }
    }
    
   

    this.setState({updateVoterModifiLoadingSymbol:"show"});
        const obj =  
            JSON.stringify({ 
            "chatId" :this.state.chatID,
            "voterIdStr" : this.state.voterIdEncodeValSet,
            "residenceStatusId" : this.state.reasonAddIdStr,
            "casteStateId" : this.state.casteIdStr,
            "partyId" : this.state.partyIdStr,
            "mobileNo" : this.state.VMMobileNo,
            "isNonLocal" : this.state.is_nonLocalVoter,
            "latitude": this.state.getCurrentLocationCoordinatesForVV.latitude,
            "longitude": this.state.getCurrentLocationCoordinatesForVV.longitude,
            "location":this.state.locationUpdated,

            }); 

            getAPICallData(obj,"verification/updateVoterVerification")
            .then((res) => res.json())
            .then((data) => {
              this.setState({updateVoterModifiLoadingSymbol:"hide"});  
                if(data !=null && data.status == "Success"){
                    this.setState({updateVoterModifiMsg:"Updated SuccessFully..."}); 

                    this.change_status_VV(this.state.VMDetailsInABoothArr)   

                    setTimeout(() => { 
                        this.setState({updateVoterVerificationModel:false});
                        
                        this.setState({updateVoterFldMsg:"",getCurrentLocationCoordinatesForVV:{}});  
                        this.setState({partyIdStr:"",mobileNoStr:"",casteIdStr:"",partyIdStrValue:"",casteIdStrValue:"",
                        reasonAddIdStr:"",reasonAddStrValue:"",is_nonLocalVoter:"",is_nonLocalVoter_value:"",locationUpdated:""
                        });
                        
                        
                    }, 1500);
                }else{
                    this.setState({updateVoterModifiMsg:"Some Thing Wrong,Please Check once"});  
                   
                }
          });
}

change_status_VV = (_data) => {
    for(var key in _data){
        if(_data[key].voterIdDecode == this.state.voterIdDeocodeValSet){
            if(this.state.partyIdStr != ""){
                _data[key].isPartyUpdated = 'Y'
            }else{
                _data[key].isPartyUpdated = 'N'
            }

            if(this.state.reasonAddIdStr != ""){
                _data[key].isStatusUpdated = 'Y'
            }else{
                _data[key].isStatusUpdated = 'N'
            }

            if(this.state.VMMobileNo != ""){
                _data[key].isMobileUpdated = 'Y'
            }else{
                _data[key].isMobileUpdated = 'N'
            }

            if(this.state.casteIdStr != ""){
                _data[key].isCasteUpdated = 'Y'
            }else{
                _data[key].isCasteUpdated = 'N'
            }
            if(this.state.is_nonLocalVoter != ""){
                _data[key].isNonLocalUpdated = 'Y'
            }else{
                _data[key].isNonLocalUpdated = 'N'
            }


        }
    }
    console.log("_data",_data) ;
    this.setState({VMDetailsInABoothArr:_data});
}

votersBlockBlockShow = (blockType) => {
    this.setState({ votersShowBlockType: blockType});
    this.setState({ VMDetailsBlockShow:false});
    this.setState({ VMDetailsInABoothCheck: 0,VMDetailsInABoothArr:[]});

    if(blockType == "2024JAN"){
      this.setState({ attributesBlock: true});
      this.setState({ votersBlock: false});
      this.setState({ votersAD2023JANOCTBlock: false});
      
    }else if(blockType == "AD2024JAN"){
      this.setState({ votersBlock: true});
      this.setState({ attributesBlock: false});
      this.setState({ votersAD2023JANOCTBlock: false});
    }else{
        this.setState({ votersBlock: false});
        this.setState({ attributesBlock: false});
        this.setState({ votersAD2023JANOCTBlock: true});
        
      }

  }
  refreshTable2023Oct = () => {
    this.getVoterVerificationUpdationStatus('',"Booth");
  }
    render() {
      
        return (
            <section>
               <Container>
                <Row>
                    <Col sm={12} className='mt-4'>
                        <div className='flex_programs_block pos_top_cls '>
                            <div className={this.state.attributesBlock == true ? "border_bottom_issues_w_in cusor_pointer" : "cusor_pointer"} onClick={() => this.votersBlockBlockShow("2024JAN")}><h6 className='fw-bold f-14  text-center'><i className='fa-solid fa-file-circle-plus'></i><span className='ms-2'>2024 JAN Voters</span></h6></div>
                            <div className={this.state.votersBlock == true ? "border_bottom_issues cusor_pointer" : "cusor_pointer"} onClick={() => this.votersBlockBlockShow("AD2024JAN")}><h6 className='fw-bold text-center f-14'><i className="fa-solid fa-person-circle-check"></i><span className='ms-2'>AD 2024 JAN</span></h6></div>
                        </div>

                        <div className='flex_programs_block  mt-1'>
                            <div className={this.state.votersAD2023JANOCTBlock == true ? "border_bottom_issues cusor_pointer" : "cusor_pointer"} onClick={() => this.votersBlockBlockShow("2023ADJANOCT")}><h6 className='fw-bold f-14 text-center'><i className="fa-solid fa-person-circle-check"></i><span className='ms-2'>AD 2023 Jan-Oct</span></h6></div>
                        </div>
                        
                    </Col>
                </Row>
                <hr/>
                {
                     this.state.votersShowBlockType == "2024JAN" ?
                     (
                        <>
                        <Row>
                        <Col>
                            <h6 className='text-center fw-bold text-decoration-underline'>2024 JAN Voter Verification</h6>
                            
                        </Col>
                    </Row>
                    {/*<Row>
                        <Col className='w_80'>
                            <h6 className="form-label f-14 fw-bold">Booth<span className='color_red f-14 ms-1'>*</span> <span className='color_red f-12'>{this.state.validateboothId}</span></h6>
                                <SelectBox
                                    stateData={this.state.boothIdValue}
                                    handleChange={this.handleOnchangeSelectBoxNew}
                                    name="boothId"
                                    options={this.state.boothIdsList}
                                    placeholderName={'Select Booth'}
                                    dropdownIndicator={{ DropdownIndicator }}
                                />
                        </Col>
                        
                        </Row>*/}
                
                    
                    {
                        this.state.votersUpdatesArr.length == 0 ?
                        (
                            this.state.votersUpdateCheck == 1 ?
                            (<Col className='f-14 text-center mt-3'>No Data Available</Col>)
                            :
                            (<Col sm={12}>
                            <div class="spinner-border color_yellow loading-img-center mt-4"></div>
                            </Col>)
                        )
                        :
                        (
                            this.state.votersUpdatesArr.length>0 ? 
                            (
                                <Row>
                                    <Col sm={12}>
                                        <div className='bg_light_blue mt-2'>
                                        <h6 className='f-12 mt-3 fw-bold'>
                                                Note : <span className='ml_5 mr_2'>V - Verified,</span>
                                                        <span className='ml_5 mr_2'>P - Pending</span>
                                                        <OverlayTrigger key={"top"} placement={"top"}
                                                            overlay={
                                                            <Tooltip id={`tooltio-Filter`}>
                                                                <h6 className='f-14'>Refresh</h6>
                                                            </Tooltip>
                                                            }
                                                        >
                                                        <i class="fa-solid fa-arrows-rotate float-end cursor_pointer f-14" onClick={() => this.refreshTable2023Oct()}></i>     
                                                        </OverlayTrigger>
                                            </h6>
                                            <CardLessDataTableWithSearchLimit10 
                                                parentData={this.votersUpdatesDisplayData()}
                                                particlecolumns={this.votersUpdatesDisplayColumns()}
                                                defaultSorted={[{
                                                    dataField: "Deleted",
                                                    order: "desc"
                                                }]}
                                            tableHeading=""
                                            />
                                        </div>
                                    </Col>
                                </Row>
                            )
                            :
                            ("")
                        )
                        
                        }
                        
                        <div className='scroll_top_VM'>
                        {
                            this.state.VMDetailsBlockShow == true ?
                            (
                                <>
                                 <div className='bg_light_blue mt-2'>
                                <Row>
                                    <Col className='w_80'>
                                        <h6 className="form-label f-14 fw-bold mt-4">{this.state.VMTableHeading}</h6>
                                    </Col>
                                    <Col className='w_20'>
                                        <OverlayTrigger key={"top"} placement={"top"}
                                            overlay={
                                                <Tooltip id={`tooltio-Filter`}>
                                                <h6 className='f-14'>Show Filter</h6>
                                                </Tooltip>
                                            }
                                            >
                                            <h6 className='float-right cursor_pointer color_red filter_pos' onClick={() => this.isFilterBlockOpenVAC()}><i class="fa-solid fa-filter f-28" ></i></h6>   
                                        </OverlayTrigger>
                                        
                                    </Col>
                                </Row>
                                
                                {
                                    this.state.filterBlockOpenVAC == true ? 
                                    (
                                        <>
                                        <Row>
                                            <Col>
                                                <h6 className='mt-3'>
                                                    <span className="form-label f-14 fw-bold ml-0">
                                                        Residence Status : 
                                                    </span>
                                                    <span className='me-4'>
                                                        <Form.Check
                                                            inline
                                                            label={"All"}
                                                            name="voterParameterResidenceStatus"
                                                            type="radio"
                                                            id="residenceStatusAllId"
                                                            onChange={(e)=>this.checkParameterValue(e,'','residenceStatus')}
                                                            className="color_black f-14 pos_name_align"
                                                            checked={this.state.residenceStatusCheckedCondAll}
                                                        />
                                                        <Form.Check
                                                            inline
                                                            label={"Yes"}
                                                            name="voterParameterResidenceStatus"
                                                            type="radio"
                                                            id="residenceStatusYesId"
                                                            onChange={(e)=>this.checkParameterValue(e,'Y','residenceStatus')}
                                                            className="color_black f-14 pos_name_align"
                                                            checked={this.state.residenceStatusCheckedCondYes}
                                                        />
                                                        
                                                        <Form.Check
                                                            inline
                                                            label={"No"}
                                                            name="voterParameterResidenceStatus"
                                                            type="radio"
                                                            id="residenceStatusNoId"
                                                            onChange={(e)=>this.checkParameterValue(e,'N','residenceStatus')}
                                                            className="color_black f-14 pos_name_align"
                                                            checked={this.state.residenceStatusCheckedCondNo}
                                                        />
                                                    </span>
                                                </h6>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <h6 className='mt-3'>
                                                    <span className="form-label f-14 fw-bold ml-0">
                                                        Caste Updated : 
                                                    </span>
                                                    <span className='me-4'>
                                                        <Form.Check
                                                            inline
                                                            label={"All"}
                                                            name="voterParameter"
                                                            type="radio"
                                                            id="casteAllId"
                                                            onChange={(e)=>this.checkParameterValue(e,'','caste')}
                                                            className="color_black f-14 pos_name_align"
                                                            checked={this.state.casteCheckedCondAll}
                                                        />
                                                        <Form.Check
                                                            inline
                                                            label={"Yes"}
                                                            name="voterParameter"
                                                            type="radio"
                                                            id="casteYesId"
                                                            onChange={(e)=>this.checkParameterValue(e,'Y','caste')}
                                                            className="color_black f-14 pos_name_align"
                                                            checked={this.state.casteCheckedCondYes}
                                                        />
                                                        
                                                        <Form.Check
                                                            inline
                                                            label={"No"}
                                                            name="voterParameter"
                                                            type="radio"
                                                            id="casteNoId"
                                                            onChange={(e)=>this.checkParameterValue(e,'N','caste')}
                                                            className="color_black f-14 pos_name_align"
                                                            checked={this.state.casteCheckedCondNo}
                                                        />
                                                    </span>
                                                </h6>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <h6 className='mt-2'>
                                                    <span className="form-label f-14 fw-bold ml-0">
                                                        Party Updated : 
                                                    </span>
                                                    <span className='me-4'>
                                                        <Form.Check
                                                            inline
                                                            label={"All"}
                                                            name="voterParameterParty"
                                                            type="radio"
                                                            id="partyAllId"
                                                            onChange={(e)=>this.checkParameterValue(e,'','party')}
                                                            className="color_black f-14 pos_name_align"
                                                            checked={this.state.partyCheckedCondAll}
                                                        />
                                                        <Form.Check
                                                            inline
                                                            label={"Yes"}
                                                            name="voterParameterParty"
                                                            type="radio"
                                                            id="partyYesId"
                                                            onChange={(e)=>this.checkParameterValue(e,'Y','party')}
                                                            className="color_black f-14 pos_name_align"
                                                            checked={this.state.partyCheckedCondYes}
                                                        />
                                                        
                                                        <Form.Check
                                                            inline
                                                            label={"No"}
                                                            name="voterParameterParty"
                                                            type="radio"
                                                            id="partyNoId"
                                                            onChange={(e)=>this.checkParameterValue(e,'N','party')}
                                                            className="color_black f-14 pos_name_align"
                                                            checked={this.state.partyCheckedCondNo}
                                                        />
                                                    </span>
                                                </h6>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <h6 className='mt-2'>
                                                    <span className="form-label f-14 fw-bold ml-0">
                                                        Mobile Updated:
                                                    </span>
                                                    <span className='me-4'>
                                                        <Form.Check
                                                            inline
                                                            label={"All"}
                                                            name="voterParameterMobile"
                                                            type="radio"
                                                            id="mobileAllId"
                                                            onChange={(e)=>this.checkParameterValue(e,'','mobile')}
                                                            className="color_black f-14 pos_name_align"
                                                            checked={this.state.mobileCheckedCondAll}
                                                        />
                                                        <Form.Check
                                                            inline
                                                            label={"Yes"}
                                                            name="voterParameterMobile"
                                                            type="radio"
                                                            id="mobileYesId"
                                                            onChange={(e)=>this.checkParameterValue(e,'Y','mobile')}
                                                            className="color_black f-14 pos_name_align"
                                                            checked={this.state.mobileCheckedCondYes}
                                                        />
                                                        
                                                        <Form.Check
                                                            inline
                                                            label={"No"}
                                                            name="voterParameterMobile"
                                                            type="radio"
                                                            id="mobileNoId"
                                                            onChange={(e)=>this.checkParameterValue(e,'N','mobile')}
                                                            className="color_black f-14 pos_name_align"
                                                            checked={this.state.mobileCheckedCondNo}
                                                        />
                                                    </span>
                                                </h6>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <h6 className='mt-2'>
                                                    <span className="form-label f-14 fw-bold ml-0">
                                                        Is Non Local : 
                                                    </span>
                                                    <span className='me-4'>
                                                        <Form.Check
                                                            inline
                                                            label={"All"}
                                                            name="voterParameterNonLocal"
                                                            type="radio"
                                                            id="nonLocalAllId"
                                                            onChange={(e)=>this.checkParameterValue(e,'','nonLocal')}
                                                            className="color_black f-14 pos_name_align"
                                                            checked={this.state.nonLocalCheckedCondAll}
                                                        />
                                                        <Form.Check
                                                            inline
                                                            label={"Yes"}
                                                            name="voterParameterNonLocal"
                                                            type="radio"
                                                            id="nonLocalYesId"
                                                            onChange={(e)=>this.checkParameterValue(e,'Y','nonLocal')}
                                                            className="color_black f-14 pos_name_align"
                                                            checked={this.state.nonLocalCheckedCondYes}
                                                        />
                                                        
                                                        <Form.Check
                                                            inline
                                                            label={"No"}
                                                            name="voterParameterNonLocal"
                                                            type="radio"
                                                            id="nonLocalNoId"
                                                            onChange={(e)=>this.checkParameterValue(e,'N','nonLocal')}
                                                            className="color_black f-14 pos_name_align"
                                                            checked={this.state.nonLocalCheckedCondNo}
                                                        />
                                                    </span>
                                                </h6>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Button variant="dark" className='f-12 center-auto mt-4' onClick={() => this.getBoothWiseVotersUpdateDetila(0,'',"","withFilters","")}>SUBMIT</Button> 
                                            </Col>
                                        </Row>
                                        </>


                                    )
                                    :
                                    ("")
                                }
                                {
                                    this.state.VMDetailsInABoothArr.length == 0 ?
                                    (
                                        this.state.VMDetailsInABoothCheck == 1 ?
                                        (<Col className='f-14 text-center mt-3'>No Data Available</Col>)
                                        :
                                        (<Col sm={12}>
                                        <div class="spinner-border color_yellow loading-img-center mt-4"></div>
                                        </Col>)
                                    )
                                    :
                                    (
                                        this.state.VMDetailsInABoothArr.length>0 ? 
                                        (
                                            <>
                                            
                                            <Row>
                                                <Col sm={12}>
                                                    <div className='bg_light_blue mt-2'>
                                                    

                                                    
                                                    <hr className='mb-0 mt-0'/>
                                                    <h6 className='f-12 mt-3 fw-bold'>
                                                        Note : <span className='ml_5 mr_2'>P - Party,</span>
                                                                <span className='ml_5 mr_2'>C - Caste,</span>
                                                                <span className='ml_5 mr_2'>M - Mobile,</span>
                                                                <span className='ml_5 mr_2'>R - Residence Status</span>
                                                                <span className='ml_5 mr_2'>N - Non Local</span>
                                                    </h6>
                                                    <h6 className='f-12 mt-2 fw-bold' style={{marginLeft:"40px"}}>
                                                                <span className='ml_5 mr_2 color_green'>Y - Updated,</span>
                                                                <span className='ml_5 mr_2 color_red'>N - Not Updated,</span>
                                                                
                                                    </h6>
                                                        <CardLessDataTableSearchFilterLimit10 
                                                            parentData={this.VMDetailsDisplayData()}
                                                            particlecolumns={this.VMDetailsDisplayColumns()}
                                                            defaultSorted={[{
                                                                dataField: "serialNo",
                                                                order: "asc"
                                                            }]}
                                                        tableHeading={""}
                                                        />
                                                    </div>
                                                </Col>
                                            </Row>
                                            </>
                                        )
                                        :
                                        ("")
                                    )
                                    
                                    }
                                </div>
                                </>

                            )
                            :
                            ("")
                        }
                        </div>
                        </>
                     )
                     :
                     (
                        this.state.votersShowBlockType == "AD2024JAN" ?
                        (<VotersModificationSectionAD2024JAN />)
                        :
                        (<VotersModificationSectionAD2023JANOCT />)
                        
                     
                     )
                }
                   
                        

                        
                <UpdateVoterVerification 
                        show={this.state.updateVoterVerificationModel}
                        onHide={() => this.setState({ updateVoterVerificationModel: false })}
                        stateData={this.state}
                        phandleOnchangeSelectBoxNew={this.handleOnchangeSelectBoxNew}
                        phandleOnchangeInputBox={this.handleOnchangeInputBox}
                        pupdateVoterModifiFields={this.updateVoterModifiFields}
                        handleOnchangeAllowAlphabiticalInputBox={this.handleOnchangeAllowAlphabiticalInputBox}
                />
               </Container>
            </section>
        )
    }
  }
  
  export default withRouter(VotersVerification);
  